/* eslint-disable */ 
import React from 'react' ;
import { Colors } from '../../Common/Colors';

export default function Loader(props) {

    return <div style={{display:'flex', flexDirection:'row', justifyContent :'center', alignItems:'center', minHeight:'100vh', color : Colors.mainColor,...props.style}}>
        <i className="pi pi-spin pi-spinner" style={{'fontSize': '2em'}}></i>
    </div>
}